import Projects from "./Projects";
import Members from "./Members";

export default function SideBar() {
  return (
    <div className="sidebar">
      <Projects />
      <Members />
    </div>
  );
}
